import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyCheckboxModule } from '@vendasta/galaxy/checkbox';
import { PipelineStatusCheckboxComponent } from './pipeline-status-checkbox.component';
import { PipelineStatusCheckboxService } from './pipeline-status-checkbox.service';

@NgModule({
  declarations: [PipelineStatusCheckboxComponent],
  exports: [PipelineStatusCheckboxComponent],
  providers: [PipelineStatusCheckboxService],
  imports: [CommonModule, GalaxyCheckboxModule, ReactiveFormsModule, MatButtonModule, MatDialogModule, TranslateModule],
})
export class PipelineStatusCheckboxModule {}
